var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.icon.element ? _vm.icon.element : 'i',_vm._b({tag:"component",staticClass:"vsm--icon",class:typeof _vm.icon === 'string' || (_vm.icon instanceof String) ? _vm.icon : _vm.icon.class},'component',_vm.icon.attributes,false),[_vm._v("\n  "+_vm._s(_vm.icon.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }